export const address = {
  companyName: 'CÔNG TY TNHH DREAM CLOSETS',
  mst: '0319375412',
  address: '51 đường 41, Phường Khánh Hội, Thành phố Hồ Chí Minh, Việt Nam',
};

export const followUs = {
  facebook: 'http://www.facebook.com/rentzy.vn',
  instagram: 'http://rentzy.vn/',
  tiktok: 'http://rentzy.vn/',
};

export const email = 'rental@rentzy.vn';

export const hotline = '079 8969040';

export default {};
